// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ce-2";
export var aiChatCartContainerExit = "_ce-4";
export var aiChatContainerLarge = "_ce-0";
export var aiChatContainerSmall = "_ce-1";
export var aiChatIcon = "_ce-6";
export var slideInFromRight = "_ce-3";
export var slideOutToRight = "_ce-5";